export default __webpack_public_path__ + "static/media/Sanjay-Kaul.098ce74e.jpeg";